import { mapToUser } from "../../helpers/GlobalMapper";

const API_URL = process.env.REACT_APP_API_URL;
export const fetchUsers = async (accessToken: string, tenantId: number) => {
  try {
    
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_USER_API}?tenantId=${tenantId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to fetch users.");
    }
    const data = await response.json();
    console.log("Data without map", data);
    const mapData = mapToUser(data);
    console.log("Data mapped", mapData);
    return mapData;
  } catch (error) {
    throw error;
  }
};

export const addUser = async (
  user: any,
  accessToken: string,
  tenantId: number
) => {
  try {
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_USER_ADD_API}?tenantId=${tenantId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      }
    );
    if (!response.ok) {
      throw new Error("Failed to add user.");
    }
    // Check if the response is JSON or plain text
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json(); // Parse JSON if content-type is JSON
    } else {
      return response.text(); // Parse as plain text otherwise
    }
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (
  user: any,
  accessToken: string,
  tenantId: number
) => {
  try {
    const response = await fetch(
      `${API_URL}${process.env.REACT_APP_USER_UPDATE_API}?tenantId=${tenantId}`,
      {
        method: "POST", // Use PUT if your API expects it for updates
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      }
    );
    if (!response.ok) {
      throw new Error("Failed to update user.");
    }
    // Check if the response is JSON or plain text
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json(); // Parse JSON if the content type is JSON
    } else {
      return response.text(); // Parse plain text otherwise
    }
  } catch (error) {
    throw error;
  }
};

export const deleteUserById = async (
  userId: any,
  accessToken: string,
  tenantId: number,
  deletedBy: number
) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URL}${
      process.env.REACT_APP_USER_DELETE_API
    }?userId=${encodeURIComponent(
      userId
    )}&tenantId=${tenantId}&deletedBy=${deletedBy}`;
    console.log("Deleting User with Email:", userId, "URL:", apiUrl);
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error("Failed to delete user.");
    }
    return await response.text(); // Return plain text or success message
  } catch (error) {
    throw error;
  }
};

export const updateUserLicense = async (
  user: any,
  accessToken: string,
  tenantId: number
) => {
  
  try {
    const response = await fetch(
      `${API_URL}/api/OutlookAdmin/UserLicence?tenantId=${tenantId}`,
      {
        method: "POST", // or "PATCH" depending on your API design
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to update user license.");
    }

    // Check if the response is JSON or plain text
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json(); // Parse JSON if content-type is JSON
    } else {
      return response.text(); // Parse as plain text otherwise
    }
  } catch (error) {
    throw error;
  }
};
